/**
 * Service for calling the Trident User API and tracking the user's permissions
 * @author Joseph Blair
 */

function permissionsService($http, $log) {
  const service = {};

  service.init = async () => {
    try {
      const { data } = await $http.get('/user');
      service.permissions = data.permissions.WebSked;
    } catch (error) {
      $log.error(error);
      service.permissions = {};
    }
    return service.permissions;
  };

  service.isAuthorized = (code, website) => {
    const { permissions: { sites, global: globalPermissions } = {} } = service;
    return (
      (sites && sites[website] && sites[website].includes(code)) ||
      (globalPermissions && globalPermissions.includes(code))
    );
  };

  return service;
}

const serviceArray = ['$http', '$log', permissionsService];

module.exports = (ngModule) => {
  ngModule.factory('permissionsService', serviceArray);
};
